"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const base_client_1 = require("@soluto-private/base-client");
const common_event_1 = require("@soluto-private/common-event");
class CommonEventApiClient extends base_client_1.BaseApiClient {
    constructor(config) {
        super(config);
        this.clientApplicationName = config.clientApplicationName;
    }
    async sendEvent(eventInput) {
        const event = {
            source: this.clientApplicationName,
            ...eventInput,
        };
        const eventRequest = new common_event_1.CommonEventRequest(event);
        await common_event_1.validateCommonEvent(eventRequest);
        await this.post('/records', event);
    }
}
exports.CommonEventApiClient = CommonEventApiClient;



// WEBPACK FOOTER //
// ./node_modules/@soluto-private/common-event-api-client/dist/client.js